import React, { useState } from "react";
import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoTrashOutline,
} from "react-icons/io5";
import "../../Dashboard/pages/pages.css"; // reuse styles

const Earnings = () => {
  const [courses, setCourses] = useState([
    {
      id: 1,
      title: "React Course",
      lessons: [
        { id: 1, title: "Intro to React", earning: 50 },
        { id: 2, title: "Hooks", earning: 70 },
      ],
    },
    {
      id: 2,
      title: "Node Course",
      lessons: [
        { id: 1, title: "Node Basics", earning: 60 },
        { id: 2, title: "Express", earning: 80 },
      ],
    },
  ]);

  const [expandedCourse, setExpandedCourse] = useState(null);

  // Delete course
  const deleteCourse = (courseId) => {
    setCourses(courses.filter((c) => c.id !== courseId));
  };

  // Calculate total earnings per course
  const totalEarnings = (course) =>
    course.lessons.reduce((sum, lesson) => sum + lesson.earning, 0);

  return (
    <div className="overview-container">
      <h2>Earnings Dashboard</h2>

      <table className="lessons-table">
        <thead>
          <tr>
            <th>Course</th>
            <th>Total Lessons</th>
            <th>Total Earnings ($)</th>
            <th>Lessons Details</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {courses.map((course) => (
            <React.Fragment key={course.id}>
              <tr>
                <td>{course.title}</td>
                <td>{course.lessons.length}</td>
                <td>{totalEarnings(course)}</td>

                {/* Expand Lessons */}
                <td>
                  {course.lessons.length > 0 ? (
                    <button
                      className="lesson-btn"
                      onClick={() =>
                        setExpandedCourse(
                          expandedCourse === course.id ? null : course.id,
                        )
                      }
                    >
                      {expandedCourse === course.id ? (
                        <IoChevronUpOutline />
                      ) : (
                        <IoChevronDownOutline />
                      )}
                    </button>
                  ) : (
                    <span className="no-lessons">No Lessons</span>
                  )}
                </td>

                <td>
                  <button
                    className="delete-btn"
                    onClick={() => deleteCourse(course.id)}
                  >
                    <IoTrashOutline />
                  </button>
                </td>
              </tr>

              {/* Expanded Lessons Table */}
              {expandedCourse === course.id && course.lessons.length > 0 && (
                <tr>
                  <td colSpan="5">
                    <table className="inner-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Lesson</th>
                          <th>Earnings ($)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {course.lessons.map((lesson, idx) => (
                          <tr key={lesson.id}>
                            <td>{idx + 1}</td>
                            <td>{lesson.title}</td>
                            <td>{lesson.earning}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Earnings;
